// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApiDbAuraInstanceIdResponse,
  BackupBackup,
  BackupSnapshots,
  TypesDatabase,
  TypesDatabaseMetadata,
} from '../models/index';
import {
  ApiDbAuraInstanceIdResponseFromJSON,
  ApiDbAuraInstanceIdResponseToJSON,
  BackupBackupFromJSON,
  BackupBackupToJSON,
  BackupSnapshotsFromJSON,
  BackupSnapshotsToJSON,
  TypesDatabaseFromJSON,
  TypesDatabaseToJSON,
  TypesDatabaseMetadataFromJSON,
  TypesDatabaseMetadataToJSON,
} from '../models/index';

export interface DbidAurainstanceidGetRequest {
  dbid: string;
}

export interface DbidDetailsGetRequest {
  dbid: string;
}

export interface DbidFeaturesGetRequest {
  dbid: string;
}

export interface DbidRestoreSsoConfigPostRequest {
  dbid: string;
}

export interface DbidSnapshotsBackupidDetailsGetRequest {
  dbid: string;
  backupid: string;
  instanceid?: string;
}

export interface DbidSnapshotsGetRequest {
  dbid: string;
  instanceid?: string;
}

export interface DbidTombstoneGetRequest {
  dbid: string;
}

export interface RootGetRequest {
  orchestra?: string;
}

/**
 *
 */
export class V2DatabasesApi extends runtime.BaseAPI {
  /**
   * Get ID of the Aura Instance this database belongs to.
   * Get Containing Aura Instance ID
   */
  async dbidAurainstanceidGetRaw(
    requestParameters: DbidAurainstanceidGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiDbAuraInstanceIdResponse>> {
    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling dbidAurainstanceidGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/{dbid}/aurainstanceid`;
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ApiDbAuraInstanceIdResponseFromJSON(jsonValue),
    );
  }

  /**
   * Get ID of the Aura Instance this database belongs to.
   * Get Containing Aura Instance ID
   */
  async dbidAurainstanceidGet(
    requestParameters: DbidAurainstanceidGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiDbAuraInstanceIdResponse> {
    const response = await this.dbidAurainstanceidGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Database
   * Get Database
   */
  async dbidDetailsGetRaw(
    requestParameters: DbidDetailsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TypesDatabase>> {
    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling dbidDetailsGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/{dbid}/details`;
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      TypesDatabaseFromJSON(jsonValue),
    );
  }

  /**
   * Get Database
   * Get Database
   */
  async dbidDetailsGet(
    requestParameters: DbidDetailsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TypesDatabase> {
    const response = await this.dbidDetailsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Database features
   * Get Database features
   */
  async dbidFeaturesGetRaw(
    requestParameters: DbidFeaturesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: boolean }>> {
    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling dbidFeaturesGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/{dbid}/features`;
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Get Database features
   * Get Database features
   */
  async dbidFeaturesGet(
    requestParameters: DbidFeaturesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: boolean }> {
    const response = await this.dbidFeaturesGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Reads the SSO config previously snapshotted to the {dbid}-sso-config-backup ConfigMap (namespace `default`) on the database\'s orchestra and applies it to the Neo4jDatabase CR. The current SSO config is NOT re-snapshotted by this endpoint, so the existing backup is preserved and the restore is idempotent. Returns 404 if no backup exists.
   * Restore a database\'s SSO config from its backup ConfigMap
   */
  async dbidRestoreSsoConfigPostRaw(
    requestParameters: DbidRestoreSsoConfigPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling dbidRestoreSsoConfigPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/{dbid}/restore-sso-config`;
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Reads the SSO config previously snapshotted to the {dbid}-sso-config-backup ConfigMap (namespace `default`) on the database\'s orchestra and applies it to the Neo4jDatabase CR. The current SSO config is NOT re-snapshotted by this endpoint, so the existing backup is preserved and the restore is idempotent. Returns 404 if no backup exists.
   * Restore a database\'s SSO config from its backup ConfigMap
   */
  async dbidRestoreSsoConfigPost(
    requestParameters: DbidRestoreSsoConfigPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: string }> {
    const response = await this.dbidRestoreSsoConfigPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Database snapshot
   * Get Database snapshot
   */
  async dbidSnapshotsBackupidDetailsGetRaw(
    requestParameters: DbidSnapshotsBackupidDetailsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BackupBackup>> {
    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling dbidSnapshotsBackupidDetailsGet().',
      );
    }

    if (requestParameters['backupid'] == null) {
      throw new runtime.RequiredError(
        'backupid',
        'Required parameter "backupid" was null or undefined when calling dbidSnapshotsBackupidDetailsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['instanceid'] != null) {
      queryParameters['instanceid'] = requestParameters['instanceid'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/{dbid}/snapshots/{backupid}/details`;
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );
    urlPath = urlPath.replace(
      `{${'backupid'}}`,
      encodeURIComponent(String(requestParameters['backupid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      BackupBackupFromJSON(jsonValue),
    );
  }

  /**
   * Get Database snapshot
   * Get Database snapshot
   */
  async dbidSnapshotsBackupidDetailsGet(
    requestParameters: DbidSnapshotsBackupidDetailsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BackupBackup> {
    const response = await this.dbidSnapshotsBackupidDetailsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Database snapshots
   * Get Database snapshots
   */
  async dbidSnapshotsGetRaw(
    requestParameters: DbidSnapshotsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BackupSnapshots>> {
    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling dbidSnapshotsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['instanceid'] != null) {
      queryParameters['instanceid'] = requestParameters['instanceid'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/{dbid}/snapshots`;
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      BackupSnapshotsFromJSON(jsonValue),
    );
  }

  /**
   * Get Database snapshots
   * Get Database snapshots
   */
  async dbidSnapshotsGet(
    requestParameters: DbidSnapshotsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BackupSnapshots> {
    const response = await this.dbidSnapshotsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Database tombstone
   * Get Database tombstone
   */
  async dbidTombstoneGetRaw(
    requestParameters: DbidTombstoneGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TypesDatabaseMetadata>> {
    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling dbidTombstoneGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/{dbid}/tombstone`;
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      TypesDatabaseMetadataFromJSON(jsonValue),
    );
  }

  /**
   * Get Database tombstone
   * Get Database tombstone
   */
  async dbidTombstoneGet(
    requestParameters: DbidTombstoneGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TypesDatabaseMetadata> {
    const response = await this.dbidTombstoneGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * List Neo4jDatabases
   * List Neo4jDatabases
   */
  async rootGetRaw(
    requestParameters: RootGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<TypesDatabase>>> {
    const queryParameters: any = {};

    if (requestParameters['orchestra'] != null) {
      queryParameters['orchestra'] = requestParameters['orchestra'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(TypesDatabaseFromJSON),
    );
  }

  /**
   * List Neo4jDatabases
   * List Neo4jDatabases
   */
  async rootGet(
    requestParameters: RootGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<TypesDatabase>> {
    const response = await this.rootGetRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
